export class ProductTypeModel {
  public id: number;
  public label: string;

  constructor() {
    this.id = null;
    this.label = null;
  }

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: ProductTypeModel[] = [];
    jsons.forEach(json => {
      refs.push(new ProductTypeModel().fromJSON(json));
    });
    return refs;
  }
}
